module.exports = __webpack_public_path__ + "img/laboratorio_4-3_2048.57a13cae.webp";